import Swiper from "swiper";
import { Navigation, Thumbs, Pagination } from "swiper/modules";

const slider = document.querySelector(".product__slider-wrapper")

let mainSlider

if (slider) {
    let side = new Swiper(".slider-side", {
        loop: true,
        slidesPerView: "auto",
        freeMode: true,
        spaceBetween: 8,
        direction: "vertical",
        watchSlidesProgress: true,
    });
    mainSlider = new Swiper(".slider-main", {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        modules: [Thumbs, Navigation, Pagination],
        thumbs: {
            swiper: side,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
    });
}

const buttons = document.querySelectorAll(".product__variation-btn");


const btnsInstock = document.querySelector(".product__btns-instock")
const btnsSoldout = document.querySelector(".product__btns-soldout")

false && buttons.forEach(button => {
    button.addEventListener("click", function (event) {
        event.preventDefault();
        const soldOut = document.querySelector(".product__sold-out")
        const variationId = this.getAttribute("data-variation-id");
        const variationImage = this.getAttribute("data-image");
        const attributesData = JSON.parse(this.getAttribute("data-attributes"));
        const form = document.querySelector(".variations_form");

        for (const attr in attributesData) {
            const selectElement = form.querySelector(`#${attr}`);
            if (selectElement) {
                selectElement.value = attributesData[attr];
                selectElement.dispatchEvent(new Event("change", { bubbles: true }));
            }
        }

        const variationInput = form.querySelector("input[name=\"variation_id\"]");
        if (variationInput) {
            variationInput.value = variationId;
        }

        buttons.forEach(btn => btn.classList.remove("active"));
        this.classList.add("active");

        const slide = document.querySelector(".product__slider-slides img")
        slide.setAttribute("src", variationImage)
        const mainSlide = document.querySelector(".product__slider-main img")
        mainSlide.setAttribute("src", variationImage)
        mainSlider.slideTo(0);



        btnsSoldout.classList.remove("active")
        btnsInstock.classList.remove("active")
        soldOut.classList.remove("active")

        if (button.classList.contains("out-of-stock")) {
            soldOut.classList.add("active")
            btnsSoldout.classList.add("active")
        } else {
            btnsInstock.classList.add("active")
        }

        jQuery(form).trigger("woocommerce_update_variation_values");
        jQuery(form).trigger("check_variations");
    });
});


function getUrlParameter(name) {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
}

const attributeKey = "attribute_pa_weight";
const attributeValue = getUrlParameter(attributeKey);

if (attributeValue) {
    const matchingButton = Array.from(buttons).find(button =>
        button.getAttribute("data-attributes") && JSON.parse(button.getAttribute("data-attributes")).pa_weight === attributeValue
    );

    if (matchingButton) {
        matchingButton.click();
    }
}


const btnNotifyMe = btnsSoldout.querySelector("a")
const notifyPopup = document.querySelector(".sold-popup")
const notifyPopupClose = notifyPopup.querySelector(".close")
const html = document.querySelector('html')
btnNotifyMe.addEventListener("click", () => {
    notifyPopup.classList.add("active")
    html.style.overflow = 'hidden'
})
notifyPopup.addEventListener("click", (event) => {
    if (!event.target.closest(".sold-popup__wrapper")) {
        notifyPopup.classList.remove("active");
        html.style.overflow = 'auto'
    }
});
notifyPopupClose.addEventListener("click", (event) => {
    event.stopPropagation();
    notifyPopup.classList.remove("active")
    html.style.overflow = 'auto'

})

const moreBtn = document.querySelector('.product__more')
moreBtn && moreBtn.addEventListener('click', () => {
    const firstSlide = document.querySelector('.product__slider-main .swiper-slide')
    console.log(firstSlide);
    
    firstSlide.click()
})